import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import './App.css';
import Login from './Components/Auth/Login';
import Register from './Components/Auth/Register';
import Suppliermst from './Components/Pages/Suppliermst';
import ItemMasterForm from './Components/Pages/ItemMasterForm';
import PurchaseOrder from './Components/Pages/PurchaseOrder';
import Dashboard from './Components/Pages/Dashboard';
import AdminDashboard from './Components/Pages/AdminDashboard';
import Indent from './Components/Pages/Indent';
import MatirialReceipt from './Components/Pages/MatirialReceipt';
import MatirialIssues from './Components/Pages/MaterialIssues';
import MatirialRequest from './Components/Pages/MatirialRequest';
import PIvs from './Components/Pages/Reports/PIvs';
import POvsMR from './Components/Pages/Reports/POvsMR';
import POvsSupplier from './Components/Pages/Reports/POvsSupplier';
import PO_TC from './Components/Pages/Reports/PO_TC';
import Stock from './Components/Pages/Reports/Stock';
import AdminLogin from './Components/Auth/AdminLogin';
import WorkOrder from './Components/Pages/WorkOrder';
import WhatsappLogin from './Components/Auth/WhatsappLogin';
import WorkOrderReport from './Components/Pages/Reports/WorkOrderReport';
import WorkOrderRec from './Components/Pages/WorkOrderRec';



function App() {

  return (
    <Router>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/suppliermasterform-suppliermasterform' element={<Suppliermst />} />
        <Route path='/itemmasterform-itemmasterform' element={<ItemMasterForm />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/admindashboard-admindashboard' element={<AdminDashboard />} />
        <Route path='/purchaseindentform-purchaseindentform' element={<Indent />} />
        <Route path='/purchaseorder-purchaseorder' element={<PurchaseOrder />} />
        <Route path='/matirialreceipt-matirialreceipt' element={<MatirialReceipt />} />
        <Route path='/material-issues' element={<MatirialIssues />} />
        <Route path='/material-request' element={<MatirialRequest />} />
        <Route path='/piVS' element={<PIvs />} />
        <Route path='/poVSmr' element={<POvsMR />} />
        <Route path='/potc' element={<PO_TC />} />
        <Route path='/poVSsupplier' element={<POvsSupplier />} />
        <Route path='/stock' element={<Stock />} />
        <Route path='/adminlogin' element={<AdminLogin />} />
        <Route path='/word_Order' element={<WorkOrder />} />
        <Route path='/word_Orderrec' element={<WorkOrderRec />} />
        <Route path='/whatsapplogin' element={<WhatsappLogin />} />
        <Route path='/workOrderReport' element={<WorkOrderReport />} />
      </Routes>
    </Router>
  );
}

export default App;
